import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FlagIcon from "react-flag-kit/lib/FlagIcon";

import { setCoupon } from "../../store/slices/b2b/b2bCoupons.slice";
import Placeholder from "../Placeholder/PlaceholderText";
import { setDetailTeacher } from "../../store/slices/companyManager.slice";
import { getDemoClassById, getDemoClassMessages } from "../../store/middleware";

import multiIMG from "../../assets/images/flag_multilingo.png";
import { MdLanguage } from "react-icons/md";

const TableList = ({ listItems, listedItems, component, action = "teacher" }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const RenderTableItemRating = ({ index, item }) => (
    <td key={index} data-item={item.rating} className="ratingTeachers">
      <label className="label">{item.rating}</label>
    </td>
  );

  const onClickView = async (item) => {
    if (action === "teacher") {
      dispatch(setDetailTeacher(item));
      navigate(`/${component}/${item.id}`);
    }
    if (action === "coupon") {
      dispatch(setCoupon(item));
    }
    if (action === "demoClass") {
      await dispatch(getDemoClassById(item.id));
      await dispatch(getDemoClassMessages(item.id));
      navigate(`/${component}/${item.id}`);
    }
  };

  return (
    <>
      {!listedItems?.length ? (
        <Placeholder pageName="users" textMsg="No results" />
      ) : (
        <div className="bigBox bigBoxTableList">
          <table>
            <tbody>
              <tr>
                {listItems?.map(({ label }, index) => (
                  <th key={index}>{label}</th>
                ))}
              </tr>
              {listedItems?.map((item, index) => (
                <tr key={"tblList" + index}>
                  {listItems.map(({ name }, index) => {
                    switch (name) {
                      case "button":
                        return (
                          <td key={"tblRow" + index}>
                            <button className="view" onClick={() => onClickView(item)}>
                              {t("VIEW")} <i className="fa fa-angle-right" aria-hidden="true" />
                            </button>
                          </td>
                        );
                      case "rating":
                        return <RenderTableItemRating key={"tblRow" + index} item={item} index={index} />;
                      case "classLingo":
                        return (
                          <td key={"tblRow" + index}>
                            {item.languages
                              ? item.languages.map((flag, i) => <FlagIcon key={i} code={flag} />)
                              : item.classLingo.map((flag, i) => <FlagIcon key={i} code={flag} />)}
                          </td>
                        );
                      case "lingo":
                        return (
                          <td key={"tblRow" + index}>
                            {item.multiLingo ? (
                              <MdLanguage color="#3170fb" size={25} />
                            ) : item.totalClasses === "Unlimited" ? (
                              <img src={multiIMG} alt="multi" />
                            ) : (
                              item.lingo.map((flag, i) => <FlagIcon key={i} code={flag} />)
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td key={"tblRow" + index}>
                            <p>{item[name]}</p>
                          </td>
                        );
                      case "status":
                        return (
                          <td key={"tblRow" + index} data-item={String(item[name]).toUpperCase()}>
                            <p>
                              {t(
                                item[name] === "cancelledOutOfLimit" ? "CANCELLED_OUT_lIMIT" : item[name].toUpperCase(),
                              )}
                            </p>
                          </td>
                        );
                      case "msg":
                        return (
                          <td key={"tblRow" + index}>
                            <p>{String(item[name])}</p>
                          </td>
                        );
                      default:
                        return (
                          <td key={"tblRow" + index} data-item={String(item[name]).toUpperCase()}>
                            <p>{t(item[name])}</p>
                          </td>
                        );
                    }
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default TableList;
